const KreditTunaiIcon = ({ className }) => {
  return (
    <svg
      width="82"
      className={className}
      height="68"
      viewBox="0 0 82 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.3105 31.1954L50.8201 37.6405L79.6942 8.76637C81.4344 7.02619 81.4344 4.31924 79.6942 2.57905L79.372 2.2568C77.6962 0.581067 74.9248 0.581067 73.1847 2.2568L44.3105 31.1954Z"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.82 37.6405L48.4997 40.0252L42.5058 42.4743L41.0234 40.992L39.541 39.5096L41.9902 33.5156L44.3104 31.1954"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.0233 40.9919L37.9297 44.0856"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.5038 10.9576L79.0506 12.5044C80.533 13.9868 80.533 16.3715 79.0506 17.9183L73.8945 23.0744"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.8318 16.6294L65.3223 10.1843"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.06245 58.3939C7.57403 56.2025 11.6989 59.8118 11.6989 59.8118V21.5278C11.6989 18.563 9.31419 16.1783 6.34944 16.1783C3.38469 16.1783 1 18.563 1 21.5278V60.7786C1 64.1945 3.77138 66.9659 7.1873 66.9659H60.0373V33.9024"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7285 21.7212H49.1455"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M56.5562 49.1128L42.1836 63.5499H56.5562V49.1128Z" fill="#E12B25" />
      <path
        d="M23.6229 39.5739L22.1405 37.447H22.0761H20.5292V39.5739H18.7246V31.8397H22.0761C22.785 31.8397 23.3651 31.9686 23.8807 32.162C24.3963 32.4198 24.783 32.742 25.0408 33.1287C25.2986 33.5155 25.4275 34.0311 25.4275 34.6111C25.4275 35.1912 25.2986 35.7068 25.0408 36.0935C24.783 36.4802 24.3963 36.8025 23.8807 37.0603L25.6209 39.5094H23.6229V39.5739ZM23.1717 33.6444C22.9139 33.3866 22.4628 33.3221 21.9472 33.3221H20.4648V35.9646H21.9472C22.4628 35.9646 22.9139 35.8357 23.1717 35.6423C23.4295 35.3845 23.5584 35.0623 23.5584 34.6756C23.5584 34.2244 23.4295 33.9022 23.1717 33.6444Z"
        fill="#344154"
      />
      <path
        d="M31.6776 33.9022C32.1287 34.16 32.451 34.4822 32.7088 34.9978C32.9666 35.449 33.0955 35.9646 33.0955 36.6091C33.0955 37.1892 32.9666 37.7692 32.7088 38.2204C32.451 38.6715 32.1287 39.0583 31.6776 39.3161C31.2264 39.5739 30.7108 39.7028 30.1952 39.7028C29.4218 39.7028 28.8417 39.445 28.3906 38.9938V41.7652H26.6504V33.6444H28.2617V34.3533C28.7128 33.8377 29.2929 33.5799 30.1308 33.5799C30.7108 33.5154 31.2264 33.6444 31.6776 33.9022ZM30.9686 37.7692C31.2264 37.447 31.4198 37.0603 31.4198 36.5447C31.4198 36.029 31.2909 35.6423 30.9686 35.3201C30.6464 34.9978 30.3241 34.8689 29.8729 34.8689C29.4218 34.8689 29.0995 34.9978 28.7773 35.3201C28.455 35.6423 28.3261 36.029 28.3261 36.5447C28.3261 37.0603 28.455 37.447 28.7773 37.7692C29.0995 38.0915 29.4218 38.2204 29.8729 38.2204C30.3241 38.2204 30.6464 38.0915 30.9686 37.7692Z"
        fill="#344154"
      />
    </svg>
  )
}

export default KreditTunaiIcon
